export default "/fonts/vendor/summernote/dist/summernote.woff?f2bec4f2e5a73b537a3b8765092d7af4";